import apis from '@/apis';
import { RESET_DATA_PANEL } from './constants';
import { getDepartment } from '@/common/utils';
// import utils from '@/common/utils'
export const FETCH_PLANTFORM_INFO = 'FETCH_PLANTFORM_INFO';
export const RESET_PLANT_DATA = 'RESET_PLANT_DATA';

function formatData(data) {
  for (var i = 0, len = data.sourceSignInfo.length; i < len; i++) {
    data.sourceSignInfo[i].list.forEach((item, index) => {
      item.key = index;
    });
  }
  // if (data.department) {
  //   data.department.forEach(item => {
  //     item.k = utils.extractOrganization(item.k)
  //   })
  // }
}

export function fetchPlatformInfo(data) {
  return function (dispatch) {
    apis.queryPlatformData(data).then((res) => {
      if (res && res.ret === '0') {
        formatData(res.data);
        const apartmentValue = [];
        for (const key in res.data.department) {
          res.data.department[key].k = getDepartment(res.data.department[key].k);
          res.data.department[key].v = (res.data.department[key].v * 100).toFixed(1) / 1;
          apartmentValue.push(res.data.department[key].v);
          res.data.apartmentValue = apartmentValue;
        }
        for (const key in res.data.level) {
          res.data.level[key].v = (res.data.level[key].v * 100).toFixed(1) / 1;
        }
        dispatch({
          type: FETCH_PLANTFORM_INFO,
          payload: res.data,
        });
      }
    });
  };
}

export function resetPlantformData() {
  return {
    type: 'RESET_PLANT_DATA',
  };
}
const initialState = {
  plantform: {},
};

export default function plantDataInfo(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_PLANTFORM_INFO:
      return Object.assign({}, state, {
        plantform: payload,
      });
    case RESET_PLANT_DATA:
      return initialState;
    case RESET_DATA_PANEL:
      return initialState;
    default:
      return state;
  }
}
